import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';

import { DayOfRaceDate } from '@cds/betting-offer/domain-specific/horse-racing';
import { Sitecore } from '@frontend/sports/common/client-config-data-access';
import { SportConstant } from '@frontend/sports/common/core/data-access/constants';
import { HooksWireup } from '@frontend/sports/common/core/utils/hooks';
import { CdsPushStoreService } from '@frontend/sports/content-distribution/feature';
import { WinGameFixture } from '@frontend/sports/racing/feature/models';

import { BestOddsHelpService } from '../../../best-odds-guarantee/services/best-odds-help.service';
import { Promotion } from '../../../crm-offer-data/crm-offer.model';
import { CrmPromotionProviderService } from '../../../crm-promotion/crm-promotion-provider.service';
import { TodayRaceModel } from '../../../horse-racing-shared/model/day-of-race.model';
import { BaseDayOfRaceComponent } from '../tournaments/base-day-of-race.component';

@HooksWireup()
@Component({
    selector: 'ms-horses-today',
    templateUrl: 'horses-today.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class HorsesTodayComponent extends BaseDayOfRaceComponent {
    readonly today: DayOfRaceDate = DayOfRaceDate.Today;
    crmBannerPromotions: Promotion[] = [];
    nextFixtures: WinGameFixture[] = [];

    constructor(
        public sitecore: Sitecore,
        private bestOddsHelpService: BestOddsHelpService,
        private crmPromotionProvider: CrmPromotionProviderService,
        route: ActivatedRoute,
        protected override changeDetector: ChangeDetectorRef,
        pushService: CdsPushStoreService,
    ) {
        super(route, changeDetector, pushService);
        this.crmPromotionProvider.promotions$.pipe(takeUntilDestroyed()).subscribe((promos) => this.promotionChanged(promos));
    }

    override onRouteResolved(model: TodayRaceModel): void {
        this.nextFixtures = model.nextFixtures;
        super.onRouteResolved(model);
    }

    get isBOGHelpBoxVisible(): boolean {
        return this.bestOddsHelpService.shouldShowHelpBox;
    }

    onBOGHelpBoxClose(): void {
        this.bestOddsHelpService.setHelpBoxClosed();
    }

    private promotionChanged(promotions: Promotion[]): void {
        this.crmBannerPromotions = promotions.filter(
            (p) => p.banner && p.allFilters.some((f) => f.sportIds.some((id) => id === SportConstant.Horses)),
        );

        this.changeDetector.markForCheck();
    }
}
